import { render, staticRenderFns } from "./DsalesView.vue?vue&type=template&id=79aaa638&scoped=true"
import script from "./DsalesView.vue?vue&type=script&lang=js"
export * from "./DsalesView.vue?vue&type=script&lang=js"
import style0 from "./DsalesView.vue?vue&type=style&index=0&id=79aaa638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aaa638",
  null
  
)

export default component.exports